import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMembershipsStartDate } from '../../../services/store/slices/cart';
import dayjs from 'dayjs';

interface StartDateProps {}

const StartDate: FC<StartDateProps> = ({}) => {
  const dispatch = useDispatch();
  const { startDate } = useSelector(
    (state: {
      cart: {
        memberships: {
          startDate: string | null;
        };
      };
    }) => {
      return {
        startDate: state.cart.memberships.startDate,
      };
    }
  );
  const onChange = (value: any, dateString: any) => {
    dispatch(setMembershipsStartDate(dateString));
  };
  return (
    <div className="shadow p-6 space-y-4 rounded-lg min-h-[50vh]">
      <div className="space-y-4">
        <h4 className="text-color-primary text-xl ">اختر وقت بداية العضوية</h4>
        <p className="text-color-sec-title">
          قم باختيار الوقت التي تريد فيه بدأ تفعيل عضويتك{' '}
        </p>
      </div>
      <div>
        <DatePicker
          value={startDate ? dayjs(startDate) : null}
          placement="bottomLeft"
          //   open={true}
          onChange={onChange}
          disabledDate={(date: any) => {
            const d = new Date();
            d.setDate(d.getDate() - 1);
            return date.isBefore(d);
          }}
        />
      </div>
    </div>
  );
};

export default StartDate;
